import React from 'react';

import { ModalV2Id, ModalV2Props } from 'src/types/modalV2';

export type ModalV2State = {
  component: React.ComponentType<any>;
  props: ModalV2Props<React.ComponentProps<React.ComponentType<any>>>;
};

export type ModalsV2State = Record<ModalV2Id, ModalV2State | undefined>;

export type ModalsV2ContextType = {
  state: ModalsV2State;
  openModal: <TComponent extends React.ComponentType<any>>(
    component: TComponent,
    props: ModalV2Props<React.ComponentProps<TComponent>>,
  ) => void;
  closeModal: (id: ModalV2Id) => void;
  resetState: () => void;
};

export const ModalsV2Context = React.createContext<ModalsV2ContextType>({
  state: {},
  openModal: () => undefined,
  closeModal: () => undefined,
  resetState: () => undefined,
});
